import React from 'react';
import * as R from 'ramda';
import { Box, Button } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

const buildStudio2Url = ({ repoOwner, repoName, repoBranch }) =>
  `https://studio2.ironhack.tech/?owner=${encodeURIComponent(
    repoOwner,
  )}&repo=${encodeURIComponent(repoName)}&branch=${encodeURIComponent(
    repoBranch,
  )}`;

const ContentAccessButton = (props) => {
  const { record, source, onGithubOpen } = props;
  const courseId = R.pathOr('', [source, 'openedx'], record);
  const disableButtons = R.pathOr(
    false,
    [source, 'publication', 'disable_buttons'],
    record,
  );

  if (!courseId) return null;

  const isGitHubCourse = courseId.startsWith('github:');

  let url;
  let studio2Url;
  if (isGitHubCourse) {
    // expected format: github:type:repoOwner:repoName:repoBranch
    const parts = courseId.split(':');
    if (parts.length < 5) return null;

    const repoOwner = parts[2];
    const repoName = parts[3];
    const repoBranch = parts[4];
    url = `https://github.com/${repoOwner}/${repoName}/tree/${repoBranch}`;
    studio2Url = buildStudio2Url({ repoOwner, repoName, repoBranch });
  } else {
    url = `${process.env.REACT_APP_STUDIO_BASE_URL}/course/${courseId}`;
  }

  const handleGithubClick = () => {
    if (typeof onGithubOpen === 'function') {
      onGithubOpen({ source });
    }
  };

  const button = (
    <Button
      size="small"
      color="primary"
      target={disableButtons ? undefined : '_blank'}
      variant="outlined"
      href={disableButtons ? undefined : url}
      disabled={disableButtons}
      onClick={isGitHubCourse && !disableButtons ? handleGithubClick : undefined}
    >
      <OpenInNew style={{ paddingRight: '0.2em' }} />
      {isGitHubCourse ? 'GITHUB' : 'STUDIO'}
    </Button>
  );

  if (!isGitHubCourse) return button;

  return (
    <Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
      {button}
      <Button
        size="small"
        color="primary"
        target={disableButtons ? undefined : '_blank'}
        variant="outlined"
        href={disableButtons ? undefined : studio2Url}
        disabled={disableButtons}
      >
        <OpenInNew style={{ paddingRight: '0.2em' }} />
        STUDIO2
      </Button>
    </Box>
  );
};

export default ContentAccessButton;
